module.exports = __webpack_public_path__ + "media/images/front/services/coordination-0f9b768c9b11b7d82da845d289cbafc8.webp";